/* eslint-disable max-len */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InternalEquipmentEditComponent } from './internal-equipment-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/external-components/angular-material.module';
import { FlexLayoutModule } from 'ng-flex-layout';
import { SharedModule } from '../../shared/shared.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { InternalEquipmentEditCreateCalibrationComponent } from './internal-equipment-edit-create-calibration.component';
import { InternalEquipmentEditCreateCalibrationValueComponent } from './internal-equipment-edit-create-calibration-value.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { InternalEquipmentEditDatePerformancesComponent } from './internal-equipment-edit-date-performances/internal-equipment-edit-date-performances.component';
import { InternalEquipmentEditBalanceMassComponent } from './internal-equipment-edit-balance-mass/internal-equipment-edit-balance-mass.component';
import { InternalEquipmentEditMultichannelComponent } from './internal-equipment-edit-multichannel/internal-equipment-edit-multichannel.component';
import { InternalEquipmentEditSelectPerformancesComponent } from './internal-equipment-edit-select-performances/internal-equipment-edit-select-performances.component';

@NgModule({
    declarations: [InternalEquipmentEditComponent,
        InternalEquipmentEditCreateCalibrationComponent,
        InternalEquipmentEditCreateCalibrationValueComponent,
        InternalEquipmentEditDatePerformancesComponent, 
        InternalEquipmentEditBalanceMassComponent,
        InternalEquipmentEditMultichannelComponent,
        InternalEquipmentEditSelectPerformancesComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        /* Custom modules */
        AngularMaterialModule,
        SharedModule,
        PipesModule,
        /* Otros */
        FlexLayoutModule,
        MatDatepickerModule, MatMomentDateModule
    ],
    providers: [
        {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}}
      ],
    exports: [InternalEquipmentEditComponent, InternalEquipmentEditDatePerformancesComponent, InternalEquipmentEditBalanceMassComponent, InternalEquipmentEditMultichannelComponent]
})
export class InternalEquipmentEditModule { }
